import { IApiError } from '@/models/apiError.model';
import { IProperty } from '@/models/property.model';
import { IPagination } from '@/models/pagination.model';
import { TPropertyFiltersValues } from '../helpers';

export const PROPERTIES_SLICE_NAME = 'properties';

export interface PropertiesState {
  property: IProperty | null;
  properties: IProperty[] | null;
  appliedFilters: TPropertyFiltersValues | null;
  appliedSoldFilters: TPropertyFiltersValues | null;
  pagination: IPagination | null;
  itemsCount: number;
  isLoading: boolean;
  error: IApiError | null;
  isSold: boolean;
}

export const initialState: PropertiesState = {
  pagination: null,
  property: null,
  properties: null,
  itemsCount: 0,
  appliedFilters: null,
  appliedSoldFilters: null,
  isLoading: false,
  error: null,
  isSold: false,
};
